import { useContext, useMemo, useEffect, useState, useCallback } from 'react'
import styled from '@emotion/styled'
import DownloadIcon from '@mui/icons-material/GetApp'
import Typography from '@mui/material/Typography'
import {
  EnhancedTable,
  CvsNoCheckmarkHeader,
  CvsNoCheckboxRow,
  CvsImmediateActionDropdownButton,
  CvsDrawer,
  CvsPaginationFooter,
} from '@components'
import { reportContext } from '@contexts'
import { UserDetails } from './user-details'
import { t } from '@lingui/core/macro'

const FlexSpaceBetween = styled.div`
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
`

export const UserReport = () => {
  const { topUsers, fetchTopUsersReport, downloadReport } = useContext(reportContext)
  const [selectedUser, setSelectedUser] = useState()
  const userData = useMemo(() => Object.values(topUsers), [topUsers])

  useEffect(() => {
    fetchTopUsersReport()
  }, [fetchTopUsersReport])

  const onFilterChange = useCallback((term, rows) => {
    return rows.filter(
      row =>
        row.name.toLowerCase().includes(term.toLowerCase()) ||
        row.email.toLowerCase().includes(term.toLowerCase()),
    )
  }, [])

  return (
    <>
      <FlexSpaceBetween>
        <div style={{ paddingTop: 12 }}>
          <div
            style={{
              height: '60px',
              width: '140px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h6" style={{ paddingTop: '15px', paddingLeft: '28px' }}>
              {t`User report`}
            </Typography>
          </div>
        </div>
        <div style={{ padding: '28px 12px 12px 12px' }}>
          <CvsImmediateActionDropdownButton
            name="user-submissions-report-download"
            icon={<DownloadIcon />}
            options={[
              {
                title: t`All User Submissions Report`,
                action: () => downloadReport('usage'),
              },
              {
                title: t`All User Logins Report`,
                action: () => downloadReport('logins'),
              },
            ]}
          />
        </div>
      </FlexSpaceBetween>
      <EnhancedTable
        blockMultipleEdit
        keyField="id"
        orderBy="name"
        order="asc"
        FooterComponent={CvsPaginationFooter}
        HeaderComponent={CvsNoCheckmarkHeader}
        RowComponent={CvsNoCheckboxRow}
        onFilterChange={onFilterChange}
        columns={[
          { label: t`Name`, width: '20%', lookup: 'name' },
          { label: t`Email`, width: '20%', lookup: 'email' },
          {
            label: t`Submitted Codes`,
            width: '20%',
            type: 'number',
            lookup: 'submitted_codes',
          },
          {
            label: t`Last Login`,
            width: '20%',
            type: 'date',
            lookup: 'last_login',
          },
          { label: t`Last Submission`, width: '20%', type: 'date', lookup: 'last_submission' },
        ]}
        handleRowClick={setSelectedUser}
        rows={userData}
        noAdd
      />
      <CvsDrawer
        onClose={() => setSelectedUser('')}
        title={t`User`}
        visible={Boolean(selectedUser)}
      >
        <UserDetails
          onClose={() => setSelectedUser('')}
          userId={selectedUser}
          topUsers={topUsers}
        />
      </CvsDrawer>
    </>
  )
}
